

import { coreAxios } from "@/declare/api/axios"
import { Storey } from "@/declare/interface/project/storey"
import { AxiosResponse } from "axios"

/**
 * 添加楼层
 * @param data
 * @returns
 */
export function createStorey(projectUuid: string, data: Storey, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/storeys`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改楼层
 */
export function updateStorey(storeyUuid: string, data: Storey, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/storeys/${storeyUuid}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除楼层
 */
export function deleteStorey(storeyUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/storeys/${storeyUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取楼层详情
 */
export function getStorey(storeyUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/storeys/${storeyUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取楼栋下的楼层列表
 */
export function getStoreysByProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/storeys`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取下一个楼层名称
 */
export function getNextStoreyName(regionUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/regions/${regionUuid}/storeys/next-name`, {
        params: {
            ...params,
        }
    })
}